import {
  createStyles,
  Dialog,
  DialogContent,
  Icon,
  IconButton,
  InputAdornment,
  makeStyles,
  TextField,
  Theme,
} from '@material-ui/core';
import React from 'react';
import DialogTitle from '../dialog-title';
import { useSnackbar } from 'notistack';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& .MuiTextField-root': {
        margin: theme.spacing(1),
      },
    },
  })
);

interface InfoDialogProps {
  name: string;
  idRef: string;
  slugRef: string;
  open: boolean;
  onClose?: () => void;
}

function InfoDialog(props: InfoDialogProps): JSX.Element {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();

  const copyTextField = (id: string): void => {
    const tf = document.getElementById(id) as HTMLInputElement;
    tf.select();
    document.execCommand('copy');
    enqueueSnackbar('Copied to clipboard!', { variant: 'success' });
  };

  return (
    <Dialog
      open={props.open}
      onClose={props.onClose}
      className={classes.root}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle onClose={props.onClose}>{props.name}</DialogTitle>
      <DialogContent>
        <TextField
          id="id-reference"
          variant="outlined"
          label="Id reference"
          type="text"
          value={props.idRef}
          size="small"
          InputProps={{
            readOnly: true,
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={(): void => copyTextField('id-reference')}>
                  <Icon>file_copy</Icon>
                </IconButton>
              </InputAdornment>
            ),
          }}
          fullWidth
        />
        <TextField
          id="slug-reference"
          variant="outlined"
          label="Slug reference"
          type="text"
          value={props.slugRef}
          size="small"
          InputProps={{
            readOnly: true,
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  onClick={(): void => copyTextField('slug-reference')}
                >
                  <Icon>file_copy</Icon>
                </IconButton>
              </InputAdornment>
            ),
          }}
          fullWidth
        />
      </DialogContent>
    </Dialog>
  );
}

export default InfoDialog;
